import React, { useEffect, useMemo, useState } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { employeeService } from '../../services/api';
import { getEmployeeFullName } from '../../utils/names';
import { inStaffOnly } from '../../utils/staffStatus';

export default function PendingEmployeeSelector({ value, onChange }){
  const [employees, setEmployees] = useState([]);

  useEffect(()=>{
    (async()=>{
      try{
        const list = await employeeService.getAll();
        setEmployees(Array.isArray(list)?list:[]);
      }catch(e){ setEmployees([]); }
    })();
  },[]);

  // STAFF-S1 — people in staff (plus the selected one), labelled with the person's name.
  const options = useMemo(()=>[
    { id: '', label: 'All' },
    ...inStaffOnly(employees, value)
      .map(e=>({ id: e.id ?? e.Id, label: getEmployeeFullName(e) || e.email || e.Email || `#${e.id ?? e.Id}` }))
      .sort((a,b)=>a.label.localeCompare(b.label, 'bg')),
  ], [employees, value]);

  const selected = useMemo(()=> options.find(o=>o.id===value) || options[0], [options, value]);

  return (
    <Autocomplete
      size="small"
      options={options}
      getOptionLabel={(o)=>o.label||''}
      value={selected}
      isOptionEqualToValue={(o,v)=>o.id===v.id}
      onChange={(_,v)=>onChange(v?.id||'')}
      renderInput={(params)=>(<TextField {...params} label="Employee (All)" />)}
    />
  );
}
